import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@fantaz/shared/app-config';
import {
  MatchDetailsResultsForUserResponse,
  MatchResultsForUserResponse,
} from '@fantaz/shared/data-access/models';
import { map, Observable } from 'rxjs';
import { UtilsService } from './utils.service';

export interface ITimesPlayedInTournament {
  eventInstanceUuid: string;
  timesCanEnter: number;
  playInstanceCount: number;
}

@Injectable({
  providedIn: 'root',
})
export class GameHistoryService {
  constructor(
    private utilsService: UtilsService,
    private http: HttpClient,
  ) {}

  getGameHistory(params: any): Observable<MatchResultsForUserResponse> {
    return this.http
      .get<MatchResultsForUserResponse>(
        `${environment.apiBaseUrl}/event-client/api/v1/match-results`,
        { params },
      )
      .pipe(
        map((response) => {
          response.matchResultsForUser.map((matchResult) => {
            matchResult.imageUrl = this.utilsService.getEventImageUrl(
              matchResult.gameKey,
              '-box-175.png',
            );
            matchResult.highlighted = !!matchResult.prizeDetails;
            return matchResult;
          });
          return response;
        }),
      );
  }

  getTimesUserPlayed(
    eventPrototypeUuid: string,
    eventScheduleUuid: string,
  ): Observable<number> {
    let params = new HttpParams();

    params = params.append('countTimesPlayed', true);
    params = params.append('eventPrototypeUuid', eventPrototypeUuid);
    params = params.append('eventScheduleUuid', eventScheduleUuid);

    return this.http
      .get<{ timesPlayed: number }>(
        `${environment.apiBaseUrl}/event-client/api/match-results`,
        { params },
      )
      .pipe(map((response) => parseInt(String(response.timesPlayed))));
  }

  getTimesUserPlayedTournaments(
    tournamentList: string[],
  ): Observable<ITimesPlayedInTournament[]> {
    let params = new HttpParams();

    params = params.append('countTimesPlayed', true);
    params = params.append('allTournaments', true);

    const body = { eventInstances: tournamentList };
    console.log('another one');

    return this.http
      .post<{ timesPlayed: ITimesPlayedInTournament[] }>(
        `${environment.apiBaseUrl}/event-client/api/match-results`,
        body,
        { params },
      )
      .pipe(map((response) => response.timesPlayed));
  }

  getGameHistoryDetails(parameters: {
    eventScheduleUuid?: string;
    pageSize?: number;
    pageIndex?: number;
  }): Observable<MatchDetailsResultsForUserResponse> {
    let params = new HttpParams();

    params = params.append('pageSize', parameters.pageSize ?? '');
    params = params.append('pageIndex', parameters.pageIndex ?? '');

    return this.http.get<MatchDetailsResultsForUserResponse>(
      `${environment.apiBaseUrl}/event-client/api/match-results/${parameters.eventScheduleUuid}/casual`,
      { params },
    );
  }
}
